import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Hero from "../containers/Hero";
import { auth } from "../services/auth";
import { Helmet } from "react-helmet";
import styles from "../css/signUp.module.css";

export default function SignUp() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const navigate = useNavigate();
  const [errors, setErrors] = useState([]);

  const handleSignup = async (event) => {
    event.preventDefault();
    if (!email || !password || !confirmPassword) {
      // TODO: Display error messages/labels
      setErrors((errors) => [...errors, `Field are required`]);
      return;
    }
    setErrors([]);
    let count = 0;
    if (password.length <= "6") {
      setErrors((errors) => [...errors, `Password at least 6 characters`]);
      count++;
    }
    if (!password.match(/[A-Z]/)) {
      setErrors((errors) => [...errors, `Password at least 1 uppercase letter`]);
      count++;
    }
    if (!password.match(/[a-z]/)) {
      setErrors((errors) => [...errors, `Password at least 1 lowercase letter`]);
      count++;
    }
    if (!password.match(/[\d`~!@#$%\^&*()+=|;:'",.<>\/?\\\-]/)) {
      setErrors((errors) => [...errors, `Password at least 1 number or special character`]);
      count++;
    }
    if (password !== confirmPassword) {
      setErrors((errors) => [...errors, `Password & Confirm Password do not match!`]);
      count++;
    }

    if (count <= 0) {
      const response = await auth().signup({
        firstName,
        lastName,
        email,
        password,
      });
      if (response.status) {
        setErrors([]);
        navigate("/login");
      } else {
        setErrors((errors) => [...errors, response.response]);
      }
    }
    return;
  };

  return (
    <section>
      <Helmet>
        <title>Dailysocialboost | Sign Up</title>
      </Helmet>
      <Hero>
        <div className="container mx-auto px-24">
          <h2 className="text-5xl font-bold my-10">Sign Up</h2>
          <form onSubmit={handleSignup}>
            <div className="my-5">
              <label className="uppercase font-semibold" htmlFor="firstName">
                First Name
              </label>
              <input
                className={`h-8 w-full ${styles.signUpInput}`}
                type="text"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                name="firstName"
                id="firstName"
                required
              />
            </div>
            <div className="my-5">
              <label className="uppercase font-semibold" htmlFor="lastName">
                Last Name
              </label>
              <input
                className={`h-8 w-full ${styles.signUpInput}`}
                type="text"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                name="lastName"
                id="lastName"
                required
              />
            </div>
            <div className="my-5">
              <label className="uppercase font-semibold" htmlFor="email">
                Email Address
              </label>
              <input
                className={`h-8 w-full ${styles.signUpInput}`}
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                name="email"
                id="email"
                autoFocus
                required
              />
            </div>
            <div className="my-5">
              <label className="uppercase font-semibold" htmlFor="password">
                Password
              </label>
              <input
                className={`h-8 w-full ${styles.signUpInput}`}
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                name="password"
                id="password"
                required
              />
            </div>
            <div className="my-5">
              <label className="uppercase font-semibold" htmlFor="confirmPassword">
                Confirm Password
              </label>
              <input
                className={`h-8 w-full ${styles.signUpInput}`}
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                name="confirmPassword"
                id="confirmPassword"
                required
              />
            </div>
            <button
              className="my-5 px-20 py-3 uppercase rounded-3xl text-white bg-pink-350 shadow-xl hover:opacity-90 transition-all"
              type="submit"
              value="Sign Up"
            >
              Sign Up
            </button>
          </form>
          <p>
            Already have an account?{" "}
            <Link className="text-pink-350 hover:opacity-90 transition-all" to="/login">
              Log In
            </Link>
          </p>

          {errors
            ? errors?.map((error, index) => (
                <div
                  key={index + Math.random()}
                  className="flex p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400"
                  role="alert"
                >
                  <svg
                    aria-hidden="true"
                    className="flex-shrink-0 inline w-5 h-5 mr-3"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                  <div>
                    <span className="font-medium">Error!</span> {error}
                  </div>
                </div>
              ))
            : null}
        </div>
      </Hero>
    </section>
  );
}
